module.exports = __webpack_public_path__ + "static/media/unsplash.72576825.png";